import 'react-native-gesture-handler'

import { Provider } from 'react-redux'
import { useEffect } from 'react'

import { AuthExperience } from './AuthExperience'
import { initialiseAnalytics } from './firebase'
import { store } from './store'

const App = () => {
  useEffect(() => {
    const authClient = require('@monorepo/utils/auth-client') as {
      configureGoogleSignin?: () => void
    }

    authClient.configureGoogleSignin?.()
    void initialiseAnalytics()
  }, [])

  return <Provider store={store}>{<AuthExperience />}</Provider>
}

export { App }
export default App
